export default {
  SUBSCRIPTION: {
    month: 'mois',
    iap_title: 'Débloquez la version PRO',
    iap_pricecard_intro: 'Abonnement',
    iap_avantage: 'Voir les avantages BatiKal Pro',
    iap_restore: "Restaurer l'abonnement",
    iap_recover_ok: 'Votre abonnement a été restauré',
    iap_recover_nok: "Aucun abonnement n'a été trouvé",
    iap_success_purchase: 'Achat effectué. Merci de votre confiance.',
    iap_offer_trial: "{{period}} d'essai gratuit",
    iap_offer_trial_desc: 'puis {{price}} pour {{period}}',
    iap_mail: 'Envoyer vos simulations par mail',
    iap_backup: 'Sauvegarder vos simulations(cloud)',
    iap_noAds: 'Suppressions de toute les publicités',
    paiment_acceptSentence:
      "En utilisant l'application, vous vous engagez à respecter les https://app.batikal-app.com/cgu et la https://app.batikal-app.com/privacy de BatiKal",
    iap_magic_apple:
      "Votre paiement sera effectué sur votre compte iTunes. Abonnement sans engagement de durée prélevé par Apple, le montant sera prélevé 24h avant la fin de chaque période.Vous pouvez désactiver le renouvellement automatique à tout moment dans les réglages de l'iTunes Store.",

    iap_error_purchase: 'Erreur inconnue. Veuillez réessayer ultérieurement.',

    frequency_month: 'mois',
    subscribe: "S'abonner",
    cancel: "Annuler l'abonnement",
    switch: 'Choisir cette offre',
    offer_mobile_title: 'Offre Mobile',
    offer_mobile_overview: 'Offre Pro Mobile',
    offer_mobile_desc: "Suppression des publicités,envoies de mails et sauvegarde sans limites d'utilisation",
    offer_webmobile_title: 'Meilleur offre',
    offer_webmobile_overview: 'Offre Pro mobile + Web',
    offer_webmobile_desc: "Offre incluant l'accès mobile Pro  et web",
    offer_web_title: 'Offre Web',
    offer_web_overview: 'Accès au service web',
    offer_web_desc: '',
    title_page: 'Abonnement',
    select_offer: 'Choisir cette offre',
    select_selected: ' Selectionée',
    SUBSCRIPTION_TYPE_0: 'Aucun abonnement',
    SUBSCRIPTION_TYPE_1: 'Vous possedez un abonnement Mobile',
    SUBSCRIPTION_TYPE_2: 'Vous possedez un abonnement Web',
    SUBSCRIPTION_TYPE_3: 'Vous possedez un abonnement Web + Mobile'
  }
}
